import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CalcCssVarsService } from '@core/services/calc-css-vars.service';
import { AccessibilityService } from '@core/services/accessibility.service';
import { IonButton, IonHeader, IonIcon, IonSpinner, IonTitle, IonToolbar } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { DrugsStore } from '@store/drugs/drugs.store';
import { LangControlComponent } from 'src/app/components/lang-control/lang-control.component';
import { TranslateCommonService } from '@core/services/translate.service';
import { environment } from '@env/environment.prod';

@Component({
    selector: 'ncodp-header',
    imports: [
        IonHeader,
        IonToolbar,
        IonTitle,
        TranslateModule,
        IonIcon,
        LangControlComponent,
        IonButton,
        RouterLink,
        AsyncPipe,
        IonSpinner,
    ],
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
    private calcCssVarsService = inject(CalcCssVarsService);
    public isMobileView$ = this.calcCssVarsService.isMobileView$;
    private readonly accessibilityService = inject(AccessibilityService);
    private readonly translateCommonService = inject(TranslateCommonService);
    public translateChanges$ = this.translateCommonService.translateChanges$;
    private readonly drugsStore = inject(DrugsStore);
    public readonly isLoadingExport = computed(() => this.drugsStore.isLoadingExport());

    public downloadCatalog(): void {
        window.open(environment.catalogLink, '_blank');
        //@TODO return after fix this.drugsStore.exportCatalog();
    }

    public toggleAccessibilityPanel(): void {
        this.accessibilityService.togglePanel();
    }
}
